import { Route, Routes } from "react-router-dom";
import { PermissionRoute } from "../../../routes/PermissionRoute";
import HomePage from "../pages/Home";
import CustomersPage from "../pages/Customers";
import CreateCustomerPage from "../pages/Customers/create";
import LeadsPage from "../pages/Leads";
import CreateLeadPage from "../pages/Leads/create";
import ViewLeadPage from "../pages/Leads/view";
import ViewCustomerPage from "../pages/Customers/view";
import CallsPage from "../pages/Calls";
import CreateCallPage from "../pages/Calls/create";
import TasksPage from "../pages/Tasks";
import CreateTaskPage from "../pages/Tasks/create";
import MeetingsPage from "../pages/Meetings";
import CreateMeetingPage from "../pages/Meetings/create";
import ViewCallPage from "../pages/Calls/view";
import ViewTaskPage from "../pages/Tasks/view";
import ViewMeetingPage from "../pages/Meetings/view";
import SettingsPage from "../pages/Settings";

export default function CRMRoutes() {
  return(
    <Routes>
      <Route element={<PermissionRoute permission="crm.home" />}>
        <Route path="home" element={<HomePage />} />
      </Route>

      <Route element={<PermissionRoute permission="crm.leads.view" />}>
        <Route path="leads">
          <Route path="" element={<LeadsPage />} />
          <Route path="create" element={<CreateLeadPage />} />
          <Route path="edit/:id" element={<CreateLeadPage />} />
          <Route path="view/:id" element={<ViewLeadPage />} />
        </Route>
      </Route>

      <Route element={<PermissionRoute permission="crm.customers.view" />}>
        <Route path="customers">
          <Route path="" element={<CustomersPage />} />
          <Route path="create" element={<CreateCustomerPage />} />
          <Route path="edit/:id" element={<CreateCustomerPage />} />
          <Route path="view/:id" element={<ViewCustomerPage />} />
        </Route>
      </Route>

      <Route element={<PermissionRoute permission="crm.calls.view" />}>
        <Route path="calls">
          <Route path="" element={<CallsPage />} />
          <Route path="create" element={<CreateCallPage />} />
          <Route path="edit/:id" element={<CreateCallPage />} />
          <Route path="view/:id" element={<ViewCallPage />} />
        </Route>
      </Route>

      <Route element={<PermissionRoute permission="crm.tasks.view" />}>
        <Route path="tasks">
          <Route path="" element={<TasksPage />} />
          <Route path="create" element={<CreateTaskPage />} />
          <Route path="edit/:id" element={<CreateTaskPage />} />
          <Route path="view/:id" element={<ViewTaskPage />} />
        </Route>
      </Route>

      <Route element={<PermissionRoute permission="crm.meetings.view" />}>
        <Route path="meetings">
          <Route path="" element={<MeetingsPage />} />
          <Route path="create" element={<CreateMeetingPage />} />
          <Route path="edit/:id" element={<CreateMeetingPage />} />
          <Route path="view/:id" element={<ViewMeetingPage />} />
        </Route>
      </Route>

      <Route element={<PermissionRoute permission="crm.settings.manage" />}>
       <Route path="settings" element={<SettingsPage />} />
      </Route>
    </Routes>
  );
}